import WithDefaultOptionHelper from "../WithDefaultOptionHelper";

const options = [
  { value: "random", key: "random", text: "clientPanelConstants:randomSmallZoom" },
  { value: "randomAggressive", key: "randomAggressive", text: "clientPanelConstants:randomLargeZoom" },
  { value: "zoomOutCenter", key: "zoomOutCenter", text: "clientPanelConstants:zoomOutFromCenter" },
  { value: "zoomInCenter", key: "zoomInCenter", text: "clientPanelConstants:zoomInCenter" },
  {
    value: "zoomAlternateCenter",
    key: "zoomAlternateCenter",
    text: "clientPanelConstants:alternateZoomInOutCenter",
  },
  { value: "zoomInCorners", key: "zoomInCorners", text: "clientPanelConstants:zoomToCorners" },
];

export default WithDefaultOptionHelper(options);
